import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import './style.scss'
import { uriList } from "../../helpers/config";
import { sendData } from "../../services/auth";
import Swal from 'sweetalert2'
import { useSelector } from "react-redux";
import {format} from 'date-fns'

const ModalAPR = (props) => {
    const [loading, setLoading] = useState(false)
    const [apr, setAPR] = useState([])
    const [location,setLocation] = useState(null)
 
    const _login = useSelector((state) => state.login);

    useEffect(() => {

        const getData = async () => {
            setLoading(true)
            
            // Suporta ambas as estruturas: aprData (nova) e apr (antiga)
            let aprData = {}
            
            if (props.item.aprData) {
                // Nova estrutura: aprData já é um objeto
                aprData = typeof props.item.aprData === 'string' 
                    ? JSON.parse(props.item.aprData) 
                    : props.item.aprData
            } else if (props.item.apr) {
                // Estrutura antiga: apr como string JSON
                aprData = JSON.parse(props.item.apr)
            }
            
            console.log('APR Data carregada:', aprData)
            setAPR(aprData)
            setLoading(false)
        }
        getData()
    }, [props.show]);

    const handleMultiChange = (grupoIndex, itemIndex, subItemIndex = null,newValue) => {
        setAPR((prevApr) => {
            const newApr = [...prevApr.Grupo]; // Copia segura do estado
            if (subItemIndex !== null) {
                newApr[grupoIndex].Itens[itemIndex].Itens[subItemIndex].value = newValue;
            } else {
                newApr[grupoIndex].Itens[itemIndex].value = newValue
            }
            return { ...prevApr, Grupo: newApr };
        });
    };

    const handleCheckboxChange = (grupoIndex, itemIndex, subItemIndex = null,e) => {
        e.stopPropagation()
        setAPR((prevApr) => {
            const newApr = [...prevApr.Grupo];
            if (subItemIndex !== null) {
                newApr[grupoIndex].Itens[itemIndex].Itens[subItemIndex].value =
                    !newApr[grupoIndex].Itens[itemIndex].Itens[subItemIndex].value;
            } else {
                newApr[grupoIndex].Itens[itemIndex].value = !newApr[grupoIndex].Itens[itemIndex].value;
            }
            return { ...prevApr, Grupo: newApr };
        });
    };

    const ObjectMulti = ({ value, options, onChange }) => {
        return (
            <div style={{ display: "flex", gap: "25px" }}>
                {options && options.map((_item, key) => {
                    return (
                        <div key={key} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <label className="switch switch-sm" style={{ justifyContent: "center" }}>
                                <input
                                    type="checkbox"
                                    checked={_item === value} // Apenas a opção selecionada estará marcada
                                    onChange={() => onChange(_item)} // Atualiza o valor para a opção clicada
                                />
                                <span></span>
                            </label>
                            <span>{_item}</span>
                        </div>
                    );
                })}
            </div>
        );
    };

    const ObjectChecked = ({ value, description, onChange  }) => {
        let _value = value
        if (typeof value === 'string')
            _value = value.toString().toLowerCase() === 'sim'

        return (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <label className="switch switch-sm" style={{ justifyContent: "center" }}>
                    <input type="checkbox" 
                    checked={_value} 
                    onClick={(event) => event.stopPropagation()}
                    value={_value} 
                    onChange={(event) => {
                        event.stopPropagation(); // Bloqueia o fechamento do modal
                        onChange(event);
                    }}/>
                    <span></span>
                </label>
                {description && <span>{description}</span>}
            </div>
        )
    }                        

    const handleSubmit = async() => {
        await sendData({ uri: uriList("updateapr"),content: { id : props.item.id, apr : JSON.stringify(apr) }  })
        .then((res) => {
            if (res.status === 200) {
                props.onClose()
            }
        })
        .catch(error => {
            console.log(error);
        })
    }

    const handleSign = async(e) => {
        e.preventDefault()
        Swal.fire({
            title: 'Confirmação de Assinatura?',
            text: "Deseja realmente assinar a APR?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            customClass: {
                confirmButton: 'btn-size',
                cancelButton: 'btn-size'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                await sendData({ uri: uriList("sign"),content: { id : props.item.id, pessoaID : _login.usuarioid, geolocation : JSON.stringify(location) }  })
                .then((res) => {
                    console.log(res)
                    if (res.status === 200) {
                        Swal.fire({
                            title: 'Sucesso!',
                            text: 'Assinatura realizada com sucesso!',
                            confirmButtonColor: "#63A8EB",
                            icon: 'success',
                            confirmButtonText: 'OK'
                        })
                        props.onClose()
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            }
        })
    }

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
        
              setLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              });
            });
          }
    },[])

    return (
            <>
            <Modal
                show={props.show}
                size="sm"
                // fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => props.onClose()} >
                <Modal.Header closeButton  >
                    <Modal.Title id="contained-modal-title-vcenter">
                        <i className="fa fa-id-badge" /> Visualização de APR
                    </Modal.Title>
                </Modal.Header> 
                <Modal.Body style={{ height: `${(props?.item?.signaprweb || props?.item?.signresponsavel || props?.item?.signtecnico) ? "500px" : "600px"}`, padding: "0px", overflow:"auto" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginLeft: "5px", flexDirection: "column", padding: "10px" }}>
                        {apr.Grupo && apr.Grupo.map((_item, grupoIndex) => {
                            if (_item.visible) {
                                return (
                                    <div key={grupoIndex}>
                                        <div style={{ padding: "5px" }}>
                                            <span style={{ background: "#cacaca", padding: "5px", borderRadius: "5px" }}>
                                                {_item.description}
                                            </span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            {_item.Itens.map((_item1, itemIndex) => {
                                                if (Array.isArray(_item1.Itens)) {
                                                    return (
                                                        <div key={itemIndex} style={{ padding: "5px", marginLeft: "15px", display: "flex", flexDirection: "column", gap: "5px" }}>
                                                            <span style={{ background: "#f7f8f9", padding: "5px", borderRadius: "5px" }}>
                                                                {_item1.description}
                                                            </span>

                                                            {_item1.Itens.map((_item2, subItemIndex) => (
                                                                <div key={subItemIndex} style={{ marginLeft: "25px", display: "flex", gap: "5px", flexDirection: "column" }}>
                                                                    {_item2.tipo === "multi" && (
                                                                        <>
                                                                            
                                                                            {(_item2.opcoes.length === 2) ? (
                                                                                <div style={{display:"flex",  gap:"5px"}}>
                                                                                    <ObjectChecked value={_item2.value} onChange={e => handleCheckboxChange(grupoIndex, itemIndex, subItemIndex,e)}/>
                                                                                    <span>{_item2.description}</span>
                                                                                </div>

                                                                            ) : (
                                                                                <>
                                                                                    <span>{_item2.description}</span>
                                                                                    <ObjectMulti value={_item2.value} options={_item2.opcoes || []} onChange={(newValue) => handleMultiChange(grupoIndex, itemIndex, subItemIndex,newValue)}/>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {_item2.tipo === "check" && (
                                                                        <ObjectChecked value={_item2.value} description={_item2.description} onChange={e => handleCheckboxChange(grupoIndex, itemIndex,null,e)}/>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    );
                                                } else {
                                                    if (_item1.tipo === "risklevel") {
                                                        // Normaliza o valor para lowercase para comparação
                                                        const currentValue = (_item1.value || '').toString().toLowerCase().trim()
                                                        
                                                        return (
                                                            <div style={{ display: "flex", gap: "5px", margin: "15px", flexWrap:"wrap" }}>
                                                                <div onClick={(newValue) => handleMultiChange(grupoIndex, itemIndex, null,'Alto')} style={{ display: "flex", padding: "5px", background: "#dc3545", color: "#fff", borderRadius: "5px", width: "150px", justifyContent: "center", cursor:"pointer", border:`${currentValue === 'alto' ? "3px solid #000" : "0px"}` }}>
                                                                    <span>Alto</span>
                                                                </div>
                                                                <div onClick={(newValue) => handleMultiChange(grupoIndex, itemIndex, null,'Médio')} style={{ display: "flex", padding: "5px", background: "#ffc107", color: "#fff", borderRadius: "5px", width: "150px", justifyContent: "center", cursor:"pointer", border:`${currentValue === 'médio' || currentValue === 'medio' ? "3px solid #000" : "0px"}` }}>
                                                                    <span>Médio</span>
                                                                </div>
                                                                <div onClick={(newValue) => handleMultiChange(grupoIndex, itemIndex, null,'Baixo')} style={{ display: "flex", padding: "5px", background: "#20c997", color: "#fff", borderRadius: "5px", width: "150px", justifyContent: "center", cursor:"pointer", border:`${currentValue === 'baixo' ? "3px solid #000" : "0px"}` }}>
                                                                    <span>Baixo</span>
                                                                </div>
                                                                <div onClick={(newValue) => handleMultiChange(grupoIndex, itemIndex, null,'Muito Baixo')} style={{ display: "flex", padding: "5px", background: "green", color: "#fff", borderRadius: "5px", width: "150px", justifyContent: "center", cursor:"pointer", border:`${currentValue === 'muito baixo' ? "3px solid #000" : "0px"}` }}>
                                                                    <span>Muito Baixo</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    if (_item1.tipo === "texto") {
                                                        return <div style={{marginLeft:"25px"}}>
                                                                    <textarea className='form-control' rows={5} onChange={e => handleMultiChange(grupoIndex, itemIndex,null,e.target.value)}>{_item1.value}</textarea>
                                                               </div>
                                                    }
                                                    if (_item1.tipo === "check") {
                                                        return (<div style={{marginLeft:"25px", marginTop:"5px"}}>
                                                                    <ObjectChecked value={_item1.value} description={_item1.description} onChange={e => handleCheckboxChange(grupoIndex, itemIndex,null,e)}/>
                                                                </div>)
                                                    }
                                                }
                                                return null; // Evita warnings do React caso nenhuma condição seja atendida
                                            })}
                                        </div>
                                    </div>
                                );
                            } 
                        })}
                    </div>
                </Modal.Body>
                <Modal.Footer  > 
                    <div style={{width:"650px", gap:"15px", display:"flex",flexDirection:"column"}}>
                        {(props?.item?.signaprweb || props?.item?.signresponsavel || props?.item?.signtecnico) && (
                            <div style={{display:"flex", flexDirection:"column", width:"590px", padding:"5px", borderRadius:"5px", border:"1px dashed #cacaca"}}>
                                <div style={{display:"flex", flexDirection:"column"}}>
                                    <span style={{fontWeight:"bold"}}>Usuário Assinatura</span>
                                    <span style={{overflowWrap:"anywhere"}}>{apr.name || props.item.userName || 'N/A'} </span>
                                </div>
                                <div style={{display:"flex", flexDirection:"column"}}>
                                    <span style={{fontWeight:"bold"}}>Data/Hora Assinatura</span>
                                    <span style={{overflowWrap:"anywhere"}}>
                                        {apr.aprsigndate 
                                            ? format(new Date(apr.aprsigndate),'dd/MM/yyyy HH:mm')
                                            : props.item.dataresponsavel 
                                                ? format(new Date(props.item.dataresponsavel),'dd/MM/yyyy HH:mm')
                                                : 'N/A'
                                        }
                                    </span>
                                </div>
                                <div style={{display:"flex", flexDirection:"column"}}>
                                    <span style={{fontWeight:"bold"}}>Localização</span>
                                    <span style={{overflowWrap:"anywhere"}}>
                                        {apr.geolocation 
                                            ? `${apr.geolocation.latitude} | ${apr.geolocation.longitude}`
                                            : 'N/A'
                                        }
                                    </span>
                                </div>
                            </div>
                        )}
                        <div style={{display:"flex", justifyContent:"flex-end", gap:"5px"}}>
                            {props && !(props.item?.signaprweb || props.item?.signresponsavel || props.item?.signtecnico || false) && (
                                <button type="button" onClick={e => handleSign(e)} className='btn btn-primary' style={{ width: "110px", display: "flex", gap: "5px", alignItems: "center", justifyContent: "center" }}>
                                    <i className='fa fa-file-signature' />
                                    <span>Assinar</span>
                                </button>
                            )}
                            {!(props?.item?.signaprweb || props.item?.signresponsavel || props.item?.signtecnico) && (
                                <button onClick={handleSubmit} className='btn btn-success' style={{ width: "110px", display: "flex", gap: "5px", alignItems: "center", justifyContent: "center" }}>
                                    <i className='fa fa-save' />
                                    <span>Salvar</span>
                                </button>
                            )}
                            <button type="button" className='btn btn-dark' style={{ width: "110px", display: "flex", gap: "5px", alignItems: "center", justifyContent: "center" }} onClick={e => props.onClose()}>
                                <i className='fa fa-door-closed' />
                                <span>Sair</span>
                            </button>
                        </div>
                    </div>

                </Modal.Footer> 
            </Modal>
        </>
    );
};


export default ModalAPR;